import * as React from 'react';
import {Link, Navigate} from "react-router-dom";
import {IFalconConvenienceApiService, productHelper, ProductsEnum, resourcesHelper, Types} from "@falcon/services";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {Overlay} from "@athena-portal/components";

interface IState {
    quickerQuoteAvailable?: boolean
    loaded: boolean
}

export class QuoteYourWayPage extends React.Component<{}, IState> {

    private readonly pluginTemplates = new PluginTemplates();

    @lazyInject(Types.FalconConvenienceApiService)
    private readonly falconConvenienceApiService: IFalconConvenienceApiService

    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            loaded: false
        }
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Quote your way");
        this.falconConvenienceApiService
            .isQuickerQuoteAvailable()
            .subscribe((response: boolean) => {
                this.setState({
                    quickerQuoteAvailable: response,
                    loaded: true
                });
            }, () => {
                this.setState({
                    quickerQuoteAvailable: false,
                    loaded: true
                });
            });
    }

    public render() {
        return (
            <React.Fragment>
                <Overlay show={!this.state.loaded}/>
                <FalconHeader/>
                {this.state.loaded ? this.renderChoiceOptionsOrRedirect() : <></>}
                <FalconFooter/>
            </React.Fragment>
        )
    }

    private renderChoiceOptionsOrRedirect() {
        return this.state.quickerQuoteAvailable
            ?
            <div className="plugin view-or-get-quotes-page">
                <div className="text-group title plugin no-indent-desktop">
                    <h1 className="m-0">Quote your way</h1>
                </div>
                <div className="get-quote-allianz quote-panels mx-3">
                    {this.renderQuickerQuoteJourneyTile()}
                    {this.renderRegularQuoteJourneyTile()}
                </div>
            </div>
            : <Navigate to={this.getMotorNBPageLink()}/>;
    }

    private readonly renderRegularQuoteJourneyTile = () => {
        const linkToNbJourney = this.getMotorNBPageLink();
        return (
            <div id="quoteTraditionalWay" className="section-panel-quote-traditional-way">
                <div className="info-container">
                    <div className="icon">
                        <img src={`/${resourcesHelper.THEME}/img/to-do-list-icon.svg`} alt="" aria-hidden="true"/>
                    </div>
                    <div className="header">Get an online quote</div>
                    <div className="description">
                        Fill in your personal, driving and vehicle details, and we’ll use this information to generate a
                        quote for you.
                    </div>
                    <Link className="quote-btn" to={linkToNbJourney}>Get an online quote<img
                        src={`/${resourcesHelper.THEME}/img/launch-icon.svg`} alt="Launch icon"/></Link>
                </div>
            </div>)
    }

    private readonly renderQuickerQuoteJourneyTile = () => {
        return (
            <div id="quoteQuickerWay" className="section-panel-quote-quicker-way">
                <span className="new-badge">New</span>
                <div className="info-container">
                    <div className="icon">
                        <img src={`/${resourcesHelper.THEME}/img/ai-stars-icon.svg`} alt="" aria-hidden="true"/>
                    </div>
                    <div className="header">Get an AI powered quote</div>
                    <div className="description">
                        Upload your current car insurance document and we'll extract what we need. Be one of the first
                        to try this new way of getting a quote!
                    </div>
                    <Link className="quote-btn" to="#" onClick={() => this.redirectToQuickerQuote()}>Get an AI powered
                        quote<img
                            src={`/${resourcesHelper.THEME}/img/launch-icon.svg`} alt="Launch icon"/></Link>
                </div>
            </div>
        )
    }

    private getMotorNBPageLink(): string {
        const fromDashboard: boolean = window.sessionStorage.getItem("fromDashboard") === "true";

        return fromDashboard ?
            productHelper.getNewBusinessFromDashboardUrl(ProductsEnum.WOLF_MOTOR) :
            productHelper.getNewBusinessUrl(ProductsEnum.WOLF_MOTOR);
    }

    private redirectToQuickerQuote() {
        window.location.assign(this.falconConvenienceApiService.redirectToQuickerQuote());
    }
}
